import styled from 'styled-components';
import {rem} from "polished";

export default styled.h1`
    font-size: ${rem(30)};
`;
